interface ArrayItem {
	[key: string]: any
}

export function mergeArrays(
	priorityArray?: ArrayItem[],
	array2?: ArrayItem[],
	filterField?: string,
) {
	if (!array2 || !priorityArray) {
		return []
	}

	const filteredArray2 = array2.filter(
		(item2) =>
			filterField &&
			!priorityArray.some(
				(item1) => item1?.to[filterField] === item2?.to[filterField],
			),
	)

	return [...priorityArray, ...filteredArray2]
}

export function inferFilenameFromResponse(res: Response, url: string): string {
	const cd = res.headers.get('content-disposition') || ''
	const m = cd.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i)
	if (m?.[1]) {
		try {
			return decodeURIComponent(m[1].replace(/^"+|"+$/g, ''))
		} catch {
			return m[1]
		}
	}
	const tail = new URL(url).pathname.split('/').pop() || 'document.pdf'
	return tail.includes('.') ? tail : `${tail}.pdf`
}

export async function fetchPdfFile(downloadUrl: string): Promise<File> {
	const res = await fetch(downloadUrl, { mode: 'cors' })
	if (!res.ok) {
		throw new Error(`Failed to download PDF (HTTP ${res.status})`)
	}

	const blob = await res.blob()
	const filename = inferFilenameFromResponse(res, downloadUrl)
	const pdfBlob =
		blob.type && blob.type !== 'application/pdf'
			? new Blob([await blob.arrayBuffer()], { type: 'application/pdf' })
			: blob

	return new File([pdfBlob], filename, { type: 'application/pdf' })
}
